/* ══════════════════════════════════════════════════════════════════════════
   KITSTERS - MAGIC HOUR CLIP LOADER (homepage `magic` band)
   --------------------------------------------------------------------------
   Loads and starts the Magic Hour event clip only once its card is near the
   viewport, and keeps it playing.

   WHY THE <video> SHIPS WITH NO src AT ALL
     The clip is 6.5 MB and the band is 12th of 18 on the homepage - thousands
     of px below the fold. `preload="none"` on its own is not enough: Safari
     and iOS still fetch metadata for a source they can see, and a metadata
     fetch on a faststart file pulls the front of the container. So the server
     HTML carries NO src and NO <source>; the URLs live in `data-src` /
     `data-src-sd` and are promoted here. Cost at page load: 0 bytes,
     0 requests. Same shape, same reasoning as kitsters-marquee-media.js
     (CLAUDE.md §10.90).

   FAILURE BEHAVIOUR IS THE DESIGN. A <video> with only `data-src` never
   loads, and the poster <img> underneath it is a real, lazily-loaded image
   that fills the card on its own. So if this file never runs, never parses,
   or the browser refuses to autoplay (iOS Low Power Mode), the band still
   renders exactly as it did before the clip existed. That is why this is
   ~90 lines with no dependencies rather than part of kitsters-home.js.

   THE CLIP CANNOT BE PAUSED BY THE SHOPPER (owner instruction, 2026-08-19).
   It has no `controls` and the CSS gives it `pointer-events: none`, so no
   click, tap or context menu reaches it; `resume()` below puts it back if
   anything else pauses it. That resume is CAPPED - a browser that refuses to
   keep playing (Low Power Mode pauses immediately after every play()) would
   otherwise spin forever, so after RESUME_CAP consecutive forced restarts we
   stop and let the poster stand. A guard that fights the browser to a
   standstill is worse than the thing it is guarding.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__kitstersMagicVideo) return;
  window.__kitstersMagicVideo = true;

  var MARGIN = 500;      // start the fetch this far before the card is on screen
  var RESUME_CAP = 5;    // consecutive forced restarts before we give up

  function noop() {}

  function near(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight + MARGIN && r.bottom > -MARGIN;
  }

  /* Save-Data / 2g get Shopify's 270x480 transcode (3.74 MB) instead of the
     480x848 original (6.5 MB). Everyone still gets autoplay - what degrades
     is the picture, never the behaviour. */
  function wantsLightSource() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    return c.effectiveType === '2g' || c.effectiveType === 'slow-2g';
  }

  function promote(root) {
    if (root.dataset.kmvDone === '1') return;
    root.dataset.kmvDone = '1';

    var v = root.querySelector('video[data-src]');
    if (!v) return;

    var sd = v.getAttribute('data-src-sd');
    var src = (wantsLightSource() && sd) ? sd : v.getAttribute('data-src');
    v.removeAttribute('data-src');
    v.removeAttribute('data-src-sd');

    var resumes = 0;
    function play() { var p = v.play(); if (p && p.catch) p.catch(noop); }
    function resume() {
      if (document.hidden || v.ended) return;          // a hidden tab is the browser's call, not ours
      if (resumes >= RESUME_CAP) return;
      resumes++;
      play();
    }

    // Only reveal the clip once it is genuinely painting frames, so a slow or
    // refused load leaves the poster in place rather than flashing an empty box.
    v.addEventListener('playing', function () {
      resumes = 0;
      root.classList.add('is-playing');
    });
    v.addEventListener('pause', resume);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) resume(); });
    window.addEventListener('pageshow', resume);

    v.src = src;
    v.load();
    play();
  }

  function sweep(roots) {
    roots.forEach(function (r) { if (near(r)) promote(r); });
  }

  function init() {
    var roots = [].slice.call(document.querySelectorAll('[data-magic-video]'));
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; sweep(roots); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      sweep(roots);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        promote(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: MARGIN + 'px 0px' });
    roots.forEach(function (r) { io.observe(r); });

    // Belt: re-test POSITION once, for an observer that exists but is never
    // fed. Promoting unconditionally here would pull 6.5 MB on every homepage
    // load and undo the entire point of the file (CLAUDE.md §10.90).
    setTimeout(function () { sweep(roots); }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
